<template>
  <div class="new-password-page" v-if="!isSuccess">
    <ErrorModal />
    <h3 class="q-pt-lg">Geef uw nieuwe wachtwoord op</h3>
    <div class="input-fields">
      <q-input
        dense
        outlined
        v-model="newPw1"
        label="Nieuw wachtwoord"
        class="search-input pw-reset-input q-mt-sm"
        bg-color="white"
        :rules="[complexRule]"
        :bottom-slots="true"
        type="password"
        ref="newPwInput1"
      />
      <q-input
        dense
        outlined
        v-model="newPw2"
        label="Bevestig nieuw wachtwoord"
        class="search-input pw-reset-input q-mt-sm"
        bg-color="white"
        :rules="[matchRule]"
        :bottom-slots="true"
        type="password"
        ref="newPwInput2"
      />
    </div>
    <div class="submit-btn-input row justify-end">
      <q-btn
        class="q-ml-md submit-btn"
        flat
        no-caps
        color="white"
        label="Opslaan"
        @click="submitChangePassword()"
      />
    </div>
  </div>
  <div class="new-password-page q-pb-xl" v-if="isSuccess">
    <h3 class="q-pt-xl">Uw wachtwoord is ingesteld en u kunt nu 
      <router-link
        flat
        :to="{ name: 'Login' }"
        style="text-decoration: none"
      >
        inloggen
      </router-link>.</h3>
    <div class="q-pa-xl"></div>
    <div class="q-pa-xl"></div>
    <div class="q-pa-xl"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import UserService from '../services/userprofile.service';
import { useRoute } from 'vue-router';
import ErrorModal from '../components/userProfile-components/ErrorModal.vue';

export default {  
  components: {
    ErrorModal,
  },
  setup() {
    const route = useRoute();
    const newPwInput1 = ref(null);
    const newPwInput2 = ref(null);
    const newPw1 = ref('');
    const newPw2 = ref('');
    const token = ref('');
    const isSuccess = ref(false);
    onMounted(() => {
      token.value = route.params.token;
    });

    const submitChangePassword = async () => {
      var isInputValid = newPwInput1.value.validate();
      var isInputValid2 = newPwInput2.value.validate();
      if (isInputValid && isInputValid2) {
        var s = await UserService.setNewPassword(newPw1, newPw2, token);
        if(s) {
          isSuccess.value = true;
        }
      }
    };
    return {
      token,
      route,
      newPw1,
      newPw2,
      newPwInput1,
      newPwInput2,
      submitChangePassword,
      isSuccess,
      matchRule() {
        return (newPw1.value === newPw2.value) || 'Het wachtwoord en bevestiging komen niet overeen';
      },
      complexRule() {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        return pattern.test(newPw1.value) || 'Minimaal 8 tekens, waarvan 1 hoofdletter, 2 kleine letter en 1 cijfer';
      },
    };
  },
};
</script>
